import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import React, { useEffect, useRef, useState } from 'react'

const Wrapper = styled.div`
  background-color: ${p => p.theme.section.bgColor};
  max-height: 0;
  transition: max-height 300ms ease-in-out, min-height 100ms ease-in-out;
  overflow-y: hidden;
  ${p =>
    p.hasHeight &&
    `
    max-height: ${p.maxHeight || 1000}px;
    min-height: ${p.minHeight || 0}px;
  `}
`

const Accordion = ({ id, isOpen, showTooltip, children }) => {
  const [hasHeight, setHasHeight] = useState(false)
  const [maxHeight, setMaxHeight] = useState(500)
  const firstUpdate = useRef(true)
  const accordionRef = useRef(null)

  useEffect(() => {
    const div = document.getElementById(`${id}-accordion-content`)
    const height = div.getBoundingClientRect().height
    setMaxHeight(height + 80)
  }, [showTooltip])

  useEffect(() => {
    setTimeout(() => {
      setHasHeight(isOpen)
    }, [10])
    if (!isOpen) return
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    setTimeout(() => {
      const offsetTop = accordionRef.current.offsetTop
      const top = offsetTop - 200
      window.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
      })
    }, 500)
  }, [isOpen])

  return (
    <Wrapper
      ref={accordionRef}
      hasHeight={hasHeight}
      maxHeight={maxHeight}
      minHeight={showTooltip ? 400 : 0}
    >
      <div id={`${id}-accordion-content`}>{children}</div>
    </Wrapper>
  )
}

Accordion.defaultProps = {
  isOpen: false,
  children: [],
}

Accordion.propTypes = {
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.shape({})),
  showTooltip: PropTypes.bool.isRequired,
}

export default Accordion
